import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l-2 0l9 -9l9 9l-2 0","key":"svg-0"}],["path",{"d":"M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7","key":"svg-1"}],["path",{"d":"M10 12h4v4h-4z","key":"svg-2"}]]

const IconHome2 = createReactComponent('outline', 'home-2', 'Home2', __iconNode);

export default IconHome2;